// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ud-0";
export var checkoutRateBadgeLink = "_ud-1";